export const WEATHER_HOUR_RANGE = 33;
export const WEATHER_HOUR_LIST = ['00', '03', '06', '09', '12', '15', '18', '21'];
export const MEDIA_SIZE_LIST = [1120, 840];
export const NOW_DELAY_SECONDS = 60 * 12; // 12분
